<template>
  <div class="shipInquiry">
    <div class="hsHeader2 w100pc fixed">
      <div class="headerTitle">
        <van-nav-bar
          title="船只查询"
          left-text="返回"
          left-arrow
          @click-left="$router.go(-1)"
        ></van-nav-bar>
      </div>
      <div class="search">
        <van-search
          v-model="pageInfo.shipName"
          shape="round"
          background="#fff"
          placeholder="请输入船只名称"
          @search="onSearch"
          @clear="onClear"
          show-action
        >
          <template #action>
            <div class="searchSlot" @click="onSearch">搜索</div>
          </template>
        </van-search>
      </div>
    </div>

    <div class="workList">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <listItem
          v-for="(item, index) in tableList"
          :key="index"
          :info="item"
        ></listItem>
      </van-list>
    </div>
  </div>
</template>

<script>
import listItem from "./components/item";
import { getShipInfo } from "@/utils/network/interface";
export default {
  components: {
    listItem,
  },
  data() {
    return {
      tableList: [],
      pageInfo: {
        shipName: "",
        pageSize: 10,
        pageNum: 1,
      },
      total: 0,
      loading: false,
      finished: false,
    };
  },
  methods: {
    onSearch() {
      this.pageInfo.pageNum = 1;
      this.finished = false;
      getShipInfo(this.pageInfo).then((res) => {
        if (res.code === 200) {
          this.tableList = res.rows;
          this.total = res.total;
          this.pageInfo.pageNum++;
          this.loading = false;
          if (this.tableList.length >= res.total) {
            this.finished = true;
          }
        } else {
          this.finished = true;
        }
      });
    },
    onClear() {
      this.total = 0;
      this.tableList = [];
      this.finished = false;
    },
    onLoad() {
      setTimeout(() => {
        if (this.tableList.length >= this.total) {
          this.finished = true;
        } else {
          this.getData();
        }
      }, 1000);
      console.log("触底");
    },
    getData() {
      getShipInfo(this.pageInfo).then((res) => {
        if (res.code === 200) {
          this.tableList = this.tableList.concat(res.rows);
          this.pageInfo.pageNum++;
          this.total = res.total;
          this.loading = false;
          if (this.tableList.length >= res.total) {
            this.finished = true;
          }
        } else {
          this.finished = true;
        }
      });
    },
  },
};
</script>
<style lang='less' scoped>
.shipInquiry {
  padding-top: 120px;
  height: 100vh;
  background: #eeeeee;
  .hsHeader2 {
    background-color: #44b1f9;
    height: 120px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding-top: 10px;
    z-index: 3;
    ::v-deep .headerTitle {
      font-size: 16px;
      text-align: center;
      // line-height: 25px;
      margin-bottom: 15px;
      // height: 25px;
      color: #fff;
      .van-nav-bar {
        height: 40px;
        background-color: #44b1f9;
        .van-nav-bar__content {
          height: 40px;
        }
      }
      .van-nav-bar .van-icon {
        color: #fff;
      }
      .van-nav-bar__text {
        color: #fff;
      }
      .van-nav-bar__title {
        color: #fff;
      }
      .van-hairline--bottom::after {
        width: 0;
      }
    }
    .search {
      background-color: #44b1f9;
      padding: 0 15px;
      margin-bottom: 17px;
    }

    .van-search {
      padding: 0;
      padding-right: 3px;
      border-radius: 15px;
    }
    .van-search__action {
      width: 65px;
      height: 28px;
      background: #44b1f9;
      border-radius: 28px;
      text-align: center;
      line-height: 28px;
      color: #fff;
      padding: 0;
    }
  }
  .workList {
    padding-top: 10px;
  }
}
</style>